import Permissions from '@activities/account/AccountSettingActivity/components/Permissions';
import Policies from '@activities/account/AccountSettingActivity/components/Policies';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import AccountFooter from './AccountFooter';
import AccountManagement from './AccountManagement';
import Header from '../Header';

function AccountInfo() {
    const { t } = useTranslation('accountSetting');
    return (
        <Container>
            <Header title={t('header.title')} noShadow/>
            <Column as='main' spacing={10} fullWidth >
                <Column fullWidth as='section'>
                    <AccountManagement/>
                    <Permissions/>
                    <Policies/>
                </Column>
                <AccountFooter/>
            </Column>
            <IndexText color={colors.red} size='display' fontWeight='medium'>
                3
            </IndexText>
        </Container>
    );
}

const Container = styled.div`
    position: relative;
    height: 100vh;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const IndexText = styled(Text)`
    position: absolute;
    top: 250px;
    z-index: 2;
    margin-left: 70px;
`;

export default AccountInfo;
